<div class="section-title section-title--culture">
    <h2>Unsubscribe from Marketing Emails</h2>
</div>

<div class="content content--terms" style="grid-gap: 10px 0px; max-width: 1210px;">

    <p>Per the terms <a routerLink="/terms">Terms & Conditions</a> and <a routerLink="/privacy">Privacy Notice</a> you consent to receiving communications (“emails”), including but not limited to, new account confirmation and email verification, password reset, notification your order has been received and shipped back to you, payment-related issues and responses to your customer service inquiries.</p>

    <p>SGC does not sell your personal information to any third parties.</p>
        
    <p>If you have any questions regarding unsubscribing from email marketing, please contact <a routerLink="/collector-support">Collector Support</a>.</p>
        
    <p>To remove yourself from email marketing notifications from SGC, which may include special offers, promotions, special events, new website features, product information, and pricing changes, follow the steps below.</p>
    

    <h2 class="mbl-60">DIRECTIONS FOR WEB</h2>
    <p><strong>1.</strong> Login to gosgc.com</p>
    <p><strong>2.</strong> On your account dashboard, click the My Profile button.</p>
    <div>
        <img style="margin-top: 10px; width: 300px;" src="assets/img/sgc-web-marketing-dashboard-myprofile.png">
    </div>
    <p><strong>3.</strong> Locate the heading "COMMUNICATION AND MARKETING PREFERENCES"</p>
    <p><strong>4.</strong> Uncheck the box and you will be unsubscribed from marketing emails. If the box is unchecked, then you are already unsubscribed.</p>

    <div style="display: flex; flex-wrap: wrap; gap: 10px;">
        <img style="margin-top: 10px;" src="assets/img/sgc-web-marketing-enabled.png">
        <img style="margin-top: 10px;" src="assets/img/sgc-web-marketing-disabled.png">
    </div>

    <h2 class="mb-60" style="margin-top: 30px;">DIRECTIONS FOR MOBILE APP</h2>
    <p><strong>1.</strong> Login to the SGC Grading app</p>
    <p><strong>2.</strong> On the menu located at the bottom of the screen, click the "MORE" button on the right.</p>
    <p><strong>3.</strong> Click the "ACCOUNT MANAGEMENT" button on the top of the screen.</p>
    <p><strong>4.</strong> Click the "COMMUNICATION PREFERENCES" button.</p>
    <div>
        <img style="margin-top: 10px;" src="assets/img/mobile button.png">
    </div>
    <p><strong>5.</strong> Under Marketing Preferences, uncheck the box and you will be unsubscribed from marketing emails. If the box is unchecked, then you are already unsubscribed.</p>
    <div style="display: flex; flex-wrap: wrap; gap: 10px;">
        <img style="margin-top: 10px;" src="assets/img/mobile checkbox.jpg">
        <img style="margin-top: 10px;" src="assets/img/mobile checkbox unchecked.jpg">
    </div>

    <!-- <p>Per the terms of our <a routerLink="/terms">Terms and Conditions</a> and <a routerLink="/privacy">Privacy Policy</a>, you consent to receiving transactions emails; including but not limited to account signup verification, password resets, order receiving and shipping notices, and payment receipts.</p>
    <p>If you have any questions regarding unsubscribing from email marketing, please contact <a routerLink="/collector-support">Collector Support</a>.</p> -->
</div>